import { render, staticRenderFns } from "./attr-right.vue?vue&type=template&id=6282644b&scoped=true"
import script from "./attr-right.vue?vue&type=script&lang=js"
export * from "./attr-right.vue?vue&type=script&lang=js"
import style0 from "./attr-right.vue?vue&type=style&index=0&id=6282644b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6282644b",
  null
  
)

export default component.exports